import { ContractReviewState, ContractReviewUnloadState } from '../../states/ContractReview.States';
import * as actions from '../../actions/ContractReview.Actions';
import { mergeReview, sortByCreatedDesc } from './ContractReview.Shared';

/** Historial por contrato y estado de parametrización (D-6, DEC-003). */
export default function ContractReviewListReducer(state: ContractReviewState | undefined, action: any): ContractReviewState {
  const current = state ?? ContractReviewUnloadState;
  switch (action.type) {
    case actions.CONTRACT_REVIEW_GETALL_REQUEST: {
      const entry = current.listByContract[action.contractId];
      return {
        ...current,
        listByContract: {
          ...current.listByContract,
          [action.contractId]: { items: entry?.items ?? [], isLoading: true, success: undefined, error: undefined }
        }
      };
    }
    case actions.CONTRACT_REVIEW_GETALL_SUCCESS: {
      const items = sortByCreatedDesc(action.reviews ?? []);
      // El polling de la lista actualiza estado y avance del detalle sin borrar sus hallazgos.
      const byId = { ...current.byId };
      items.forEach(review => {
        if (byId[review.id]) byId[review.id] = mergeReview(byId[review.id], review);
      });
      return {
        ...current,
        byId,
        listByContract: {
          ...current.listByContract,
          [action.contractId]: { items, isLoading: false, success: true, error: undefined }
        }
      };
    }
    case actions.CONTRACT_REVIEW_GETALL_FAILURE: {
      const entry = current.listByContract[action.contractId];
      return {
        ...current,
        listByContract: {
          ...current.listByContract,
          [action.contractId]: { items: entry?.items ?? [], isLoading: false, success: false, error: action.error }
        }
      };
    }
    case actions.CONTRACT_REVIEW_PARAMETRIZATION_REQUEST:
      return {
        ...current,
        parametrizationByContract: {
          ...current.parametrizationByContract,
          [action.contractId]: { ...current.parametrizationByContract[action.contractId], isLoading: true, error: undefined }
        }
      };
    case actions.CONTRACT_REVIEW_PARAMETRIZATION_SUCCESS:
      return {
        ...current,
        parametrizationByContract: {
          ...current.parametrizationByContract,
          [action.contractId]: {
            isParameterized: !!action.status?.isParameterized,
            hasSettlements: action.status?.hasSettlements ?? null,
            // Contracts anterior a la 021 no informa canImport: sin parametrización se puede importar.
            canImport: action.status?.canImport ?? !action.status?.isParameterized,
            importBlockedReason: action.status?.importBlockedReason ?? null,
            isLoading: false,
            error: undefined
          }
        }
      };
    case actions.CONTRACT_REVIEW_PARAMETRIZATION_FAILURE:
      return {
        ...current,
        parametrizationByContract: {
          ...current.parametrizationByContract,
          [action.contractId]: { isParameterized: undefined, isLoading: false, error: action.error }
        }
      };
    default:
      return current;
  }
}
